/* BDS USA — Fabric per-sqft calculator with UK-style display parity.
   Mirrors the UK bds-fabric-calculator.js behaviour on the USA "pfab" new UI:
     • "from $X.XX /sq.ft, all-in" headline (per-sq.ft, all-in)
     • TOTAL PRICE box for the entered W x H
     • "Your bulk savings" ladder (Small/Medium/Large/X-Large) with current tier flagged
     • Upsell nudge ("Size up to N sq.ft to drop to $Y/sq.ft")
     • Seam note, 800 sq.ft cap, finishing add-ons, $1-base cart submit
   Pricing comes ONLY from #bdsusa-fab-data (variant metafields), which already
   match the USA pricing sheet — so the ladder is always sheet-accurate.
   CURRENCY: INR.

   PRICING RULE (fee-basis "line" — matches the Fabric Price app computePrice):
     total sq ft = width × height × quantity
     line total  = ceil( totalSqFt × rate  +  fee(totalSqFt)  +  finishing × qty )
       • fee/shipping is looked up by the TOTAL sq ft and added ONCE per line
       • finishing/add-ons are per piece → × qty
       • line total is rounded UP to a whole dollar
     _price (sent to cart) = ceil( lineTotal ÷ qty , to the cent )  → qty × _price never undercharges
*/
(function(){
  var FAB = {};
  function loadData(){
    try { FAB = JSON.parse((document.getElementById('bdsusa-fab-data')||{}).textContent || '{}'); }
    catch(e){ FAB = {}; }
  }

  // Finishing options + prices (USD) — identical to UK / old theme
  var FINISH = {
    "Pole Pocket": [["None",0],["Top Only",4],["Bottom Only",4],["Top & Bottom",7],["Sides Only",7],["All 4 Sides",7]],
    "Plastic Hook": [["None",0],["Top",2],["Bottom",2],["All 4 corners",8]],
    "Eyelets": [["None",0],["Every 2ft Top",0],["Every 2ft Bottom",0],["Every 2ft Top & Bottom",0],["Every 2ft All 4 Sides",0],["Eyelets All 4 Corners",0]],
    "Velcro": [["None",0],["Loop / top on back",6],["Loop / top & bottom on back",10],["Loop / all sides on back",19],["Hook / top on back",6],["Hook / top & bottom on back",10],["Hook / all sides on back",19]],
    "Support Frame": [["None",0],["Adjustable Backdrop Stand 10ft W x 8ft H",256]],
    "Design Proof": [["No Proof (Print as it is)",0],["Free Email Proof",0]]
  };
  var SEAM_LIMIT_FT = 10, MAX_SQFT = 800, CUR = '₹';
  var UNIT = {feet:1, ft:1, foot:1, inches:1/12, inch:1/12, "in":1/12, cm:0.0328084, centimeters:0.0328084, m:3.28084, metres:3.28084, meters:3.28084, metre:3.28084};

  // Bulk-savings tiers — identical to UK
  var TIERS = [
    {lbl:"Small",   lo:1,   hi:60,    band:"up to 60 sq.ft"},
    {lbl:"Medium",  lo:61,  hi:160,   band:"61–160 sq.ft"},
    {lbl:"Large",   lo:161, hi:400,   band:"161–400 sq.ft"},
    {lbl:"X-Large", lo:401, hi:99999, band:"400+ sq.ft"}
  ];

  // Per-fabric seamless limit (fabric roll width), from the USA FabricLimits sheet.
  // key = normalized fabric name; value = [limit_ft, limit_m]; "seamless" = seamless by construction (never seams).
  var SEAM_DEFAULT_M = 3.05;
  var SEAM = {
      "truekolorecofriendlywrinkleresistantfabric260gsm":[10,3.05],
      "truekolorecofriendly300dwrinkleresistantfabric185gsm":[8.5,2.59],
      "truekolorecofriendly300dflameretardantfabric185gsm":[8.5,2.59],
      "truekolorecofriendly300drecycledrpetfabric180gsm":[7.5,2.29],
      "truekolorecofriendly300dwaterproofperformancefabric190gsm":[5.2,1.58],
      "spunpolyesterpolycanvasfabric140gsm":[5.2,1.58],
      "800dhighdensitylinenlookpolyester300gsm":[4.9,1.49],
      "standardblockoutfabric300gsm":[10,3.05],
      "blockouttensionfabricflameretardant240gsm":[8.5,2.59],
      "blockoutelasticpolyesterflameretardant240gsm":[5.2,1.58],
      "blockoutsoftknitfabricflameretardant250gsm":[8.5,2.59],
      "premiumblockoutfabric250gsm":[4.9,1.49],
      "heavydutyblockoutfabricflameretardant280gsm":[8.5,2.59],
      "polypoplinknittedpolyester110gsm":[5.2,1.58],
      "polypoplinknittedpolyester115gsm":[10,3.05],
      "polypoplinshinyknittedpolyester130gsm":[5.4,1.65],
      "flannelpolyesterblanketfabric280gsm":[4.9,1.49],
      "feltpolyesterfabric280gsm":[3.3,1.01],
      "feltpennants280gsm":[3.4,1.04],
      "silkspandexpolyesterfabric180gsm":[4.9,1.49],
      "elasticpolyesterstretchfabric180gsm":[5.2,1.58],
      "twillfabricforfittedcovers160gsm":[5.2,1.58],
      "polysatinfabric120gsm":[5.2,1.58],
      "silvercoatedsatinfabric130gsm":[4.9,1.49],
      "210dripstopoxfordpolyester140gsm":[5.2,1.58],
      "oxford450dfabric240gsm":[4.9,1.49],
      "pucoated600dpolyester300gsm":[8.5,2.59],
      "tarpaulin600dfabric480gsm":[5.2,1.58],
      "polyesterlinen800dfabric260gsm":[4.9,1.49],
      "blackpucoated600dpolyester300gsmunprinted":[4.9,1.49],
      "whitepucoated600dpolyester300gsmunprinted":[4.9,1.49],
      "greypucoated600dpolyester300gsmunprinted":[4.9,1.49],
      "flameretardantsegbacklitfabric150gsm":[8.7,2.65],
      "flameretardantsegnonlitfabric260gsm":[10,3.05],
      "100dknittedpolyester95gsm":[6.6,2.01],
      "100dultrasheerpolyesterfabric100gsm":[10,3.05],
      "fluorescentknittedpolyesterfabricorange115gsm":[5.2,1.58],
      "fluorescentknittedpolyesterfabricyellow115gsm":[5.2,1.58],
      "fluorescent300dhighdensitypolyesterorange190gsm":[5.2,1.58],
      "airmeshmeshpolyester120gsm":[10,3.05],
      "210tpolyestertaffetafabric60gsm":[4.6,1.4],
      "duplexblockoutpolyester260gsm":[5.2,1.58],
      "duplexknittedpolyester115gsm":[5.2,1.58],
      "duplex100dpolyester100gsm":[5.2,1.58],
      "duplex100dpolyester75gsm":[5.2,1.58],
      "duplexspunpolyester140gsm":[5.2,1.58],
      "duplexshinysatin120gsm":[5.2,1.58],
      "duplexsatin120gsm":[5.2,1.58],
      "duplex210doxfordpolyester150gsm":[5.2,1.58],
      "crystalvelvetcarpet850gsm":[5.2,1.58],
      "seamlesstubularjersey130gsm":"seamless"
    };
  function normFab(s){ return (s||'').toString().toLowerCase().replace(/[^a-z0-9]/g,''); }

  function ready(fn){ if(document.readyState!=='loading') setTimeout(fn,0); else document.addEventListener('DOMContentLoaded',fn); }

  ready(function(){
    loadData();
    var fabricSel = document.querySelector('[id^="pfab-fabric-"]');
    var wEl = document.querySelector('[id^="pfab-width-"]');
    var hEl = document.querySelector('[id^="pfab-height-"]');
    var unitEl = document.querySelector('[id^="pfab-unit-"]');
    var qtyEl = document.querySelector('[id^="pfab-qty-"]');
    var priceEl = document.querySelector('[data-pfab-price]');
    var totalEl = document.querySelector('[data-pfab-total]');
    var form = document.querySelector('form[id^="PfabForm-"]') || document.querySelector('form[action*="/cart/add"]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var addBtn = form ? form.querySelector('[name="add"], .pfab__add, button[type="submit"]') : null;
    if(!form && !fabricSel) return;

    // Default the size to empty (0×0) so the "from $X/sq.ft, all-in" headline shows on load
    // instead of the small-size 3×3 rate. Placeholder shows 0 as a hint.
    if(wEl){ wEl.value=''; wEl.setAttribute('placeholder','0'); }
    if(hEl){ hEl.value=''; hEl.setAttribute('placeholder','0'); }

    function money(n){ return CUR + Number(n).toFixed(2); }
    function per(n){ return CUR + Number(n).toFixed(2); }
    function selFor(label){ return (form || document).querySelector('select[name="properties['+label+']"]'); }

    // Populate finishing dropdowns if the theme left them empty
    Object.keys(FINISH).forEach(function(label){
      var sel = selFor(label); if(!sel) return;
      var real = Array.prototype.filter.call(sel.options, function(o){ return (o.value||'').trim()!==''; });
      if(real.length>0) return;
      sel.innerHTML='';
      FINISH[label].forEach(function(p){
        var o=document.createElement('option'); o.value=p[0];
        o.textContent = p[1]>0 ? (p[0]+' (+'+CUR+p[1]+')') : p[0]; sel.appendChild(o);
      });
    });

    function finishingTotal(){
      var sum=0;
      Object.keys(FINISH).forEach(function(label){
        var sel=selFor(label); if(!sel) return; var v=sel.value||'';
        var a=FINISH[label]; for(var i=0;i<a.length;i++){ if(a[i][0]===v){ sum+=a[i][1]; break; } }
      });
      return sum;
    }
    function curFab(){ var v=fabricSel?fabricSel.value:''; return FAB[v] || FAB[Object.keys(FAB)[0]] || null; }
    function curFabName(){ var v=fabricSel?fabricSel.value:''; if(FAB[v]) return v; return Object.keys(FAB)[0]||''; }
    function seamFor(name){ var v=SEAM[normFab(name)]; if(v===undefined) return null; if(v==='seamless') return {seamless:true}; return {ft:v[0], m:v[1], seamless:false}; }
    function findMockupBtn(){ var els=document.querySelectorAll('a,button'); for(var i=0;i<els.length;i++){ var el=els[i]; if(el.closest && el.closest('.bdsusa-seam')) continue; var t=(el.textContent||'').toLowerCase(); if(t.indexOf('2d design preview')>=0||t.indexOf('request a free 2d')>=0||t.indexOf('request free 2d design')>=0){ return el; } } return null; }
    function bdsuSet(el,v){ if(!el) return; el.value=v; try{ el.dispatchEvent(new Event('input',{bubbles:true})); el.dispatchEvent(new Event('change',{bubbles:true})); }catch(e){} }
    function bdsuFillCsp(){ var UM={ft:'feet','in':'inches',m:'meters',cm:'cm'}; var w=document.querySelector('[id^="pfab-width"]')||document.getElementById('bds-w'); var h=document.querySelector('[id^="pfab-height"]')||document.getElementById('bds-h'); var u=document.querySelector('[id^="pfab-unit"]')||document.getElementById('bds-unit'); if(w&&w.value) bdsuSet(document.getElementById('csp-width'),w.value); if(h&&h.value) bdsuSet(document.getElementById('csp-height'),h.value); if(u&&u.value) bdsuSet(document.getElementById('csp-unit'),(UM[u.value]||u.value)); }
    function bdsuOpenCsp(){ bdsuFillCsp(); var t=document.createElement('a'); t.href='#'; t.setAttribute('data-custom-quote',''); t.style.display='none'; document.body.appendChild(t); t.click(); setTimeout(function(){ if(t.parentNode) t.parentNode.removeChild(t); },0); }
    function flatFor(sqft,d){ if(!d||!d.ranges||!d.ranges.length) return 0; for(var i=0;i<d.ranges.length;i++){ if(sqft<=d.ranges[i][1]) return (d.flats[i]||0); } return d.flats[d.flats.length-1]||0; }
    function maxSqftFor(d){ var r=d&&d.ranges; return (r&&r.length)? r[r.length-1][1] : MAX_SQFT; }
    // all-in per-sq.ft at a given TOTAL size (finishing NOT included, matches UK ladder); fee counted once
    function effAt(sz,d){ if(!sz||sz<=0||!d) return 0; var rate=parseFloat(d.rate)||0; var total=Math.ceil(sz*rate+flatFor(sz,d)); return total/sz; }

    /* ---- Build the UK-style display block (headline + total + nudge + ladder) ---- */
    var ui = null, elHead=null, elTotal=null, elNudge=null, elLadder=null;
    function buildUI(){
      if(ui) return;
      var anchor = (totalEl && (totalEl.closest('p,div')||totalEl.parentNode)) || (priceEl && priceEl.parentNode) || form;
      if(!anchor) return;
      ui = document.createElement('div');
      ui.className = 'bdsusa-calc';
      ui.style.cssText = 'margin:14px 0 0;font-family:inherit;';
      ui.innerHTML =
        '<div class="bdsusa-head" style="font-size:15px;color:#0a3161;font-weight:600;margin:0 0 8px;"></div>'+
        '<div class="bdsusa-total" style="display:none;align-items:center;justify-content:space-between;border:1px solid #e5e7eb;border-radius:10px;padding:12px 14px;margin:0 0 8px;background:#fff;">'+
          '<span style="font-size:12px;letter-spacing:.04em;color:#6b7280;text-transform:uppercase;">Total price</span>'+
          '<strong class="bdsusa-total-val" style="font-size:22px;color:#0a3161;"></strong>'+
        '</div>'+
        '<div class="bdsusa-nudge" style="display:none;font-size:12.5px;color:#15803d;margin:0 0 8px;"></div>'+
        '<div class="bdsusa-ladder-cap" style="font-size:11px;letter-spacing:.04em;color:#6b7280;text-transform:uppercase;margin:0 0 6px;">Your bulk savings (all-in, incl. free delivery)</div>'+
        '<div class="bdsusa-ladder"></div>';
      anchor.parentNode.insertBefore(ui, anchor.nextSibling);
      elHead   = ui.querySelector('.bdsusa-head');
      elTotal  = ui.querySelector('.bdsusa-total');
      elNudge  = ui.querySelector('.bdsusa-nudge');
      elLadder = ui.querySelector('.bdsusa-ladder');
    }

    function renderLadder(sqft,d){
      if(!elLadder) return;
      var mh = maxSqftFor(d), html='';
      TIERS.forEach(function(t){
        var refHi = t.hi>=99999 ? mh : Math.min(t.hi, mh);
        var te = effAt(refHi,d);
        var on = sqft>0 && sqft>=t.lo && sqft<=t.hi;
        html += '<div style="display:flex;align-items:center;justify-content:space-between;border:1px solid '+(on?'#a4143d':'#eee')+';'+
                'background:'+(on?'#fdf2f7':'#fafafa')+';border-radius:8px;padding:9px 12px;margin:0 0 6px;font-size:13px;color:'+(on?'#7a1030':'#374151')+';">'+
                '<span>'+t.lbl+' · '+t.band+(on?' — you’re here':'')+'</span>'+
                '<span style="white-space:nowrap;">as low as '+per(te)+'/sq.ft</span></div>';
      });
      elLadder.innerHTML = html;
    }

    function renderNudge(sqft,curEff,d){
      if(!elNudge) return;
      if(sqft<=0){ elNudge.style.display='none'; return; }
      var r=d&&d.ranges, nh=null;
      if(r&&r.length){ for(var i=0;i<r.length;i++){ if(sqft<r[i][1]){ nh=r[i][1]; break; } } }
      if(nh){ var ne=effAt(nh,d); if(ne<curEff-0.01){ elNudge.innerHTML='↑ Size up to '+nh+' sq.ft to drop to '+per(ne)+'/sq.ft'; elNudge.style.display='block'; return; } }
      elNudge.style.display='none';
    }

    /* ---- seam / quote notes: BOTH shown at the TOP (never at the bottom) ---- */
    var seamNote=null, quoteNote=null;
    function buildNotes(){
      var topAnchor = priceEl ? (priceEl.closest('.pfab__price') || priceEl.parentNode) : null;
      function placeTop(el){
        if(topAnchor && topAnchor.parentNode){ topAnchor.parentNode.insertBefore(el, topAnchor.nextSibling); }
        else { (ui || form || document.body).appendChild(el); }
      }
      // Seam note — GREEN, one identical message for ALL fabrics, at the TOP.
      // Includes the "FREE 2D mockup" link (opens the same modal as the page's Request-2D button) + acknowledge checkbox.
      seamNote=document.createElement('div');
      seamNote.className='bdsusa-seam';
      seamNote.style.cssText='display:none;margin:12px 0;padding:12px 14px;background:#f0fdf4;border:1px solid #16a34a;border-radius:10px;font-size:13px;color:#166534;line-height:1.5;';
      seamNote.innerHTML=
        '<div>Heads up: at this size your backdrop will have a seamline where fabric panels join. Prefer it seamless, or want to see it first? '+
        '<a href="#" class="bdsusa-seam-mockup" style="color:#15803d;font-weight:700;text-decoration:underline;">Request your FREE 2D mockup</a></div>'+
        '<label style="display:flex;align-items:center;gap:8px;margin:8px 0 0;cursor:pointer;color:#166534;">'+
        '<input type="checkbox" class="bdsusa-seam-ack" style="width:16px;height:16px;flex:0 0 auto;accent-color:#16a34a;">'+
        '<span>I understand my banner will include a stitched seam</span></label>';
      placeTop(seamNote);
      var mk=seamNote.querySelector('.bdsusa-seam-mockup');
      if(mk){ mk.addEventListener('click', function(ev){ ev.preventDefault(); var t=findMockupBtn(); if(t) t.click(); }); }
      var ack=seamNote.querySelector('.bdsusa-seam-ack');
      if(ack){ ack.addEventListener('change', function(){ seamNote.style.boxShadow=''; }); }
      // Over-800 quote note — at the TOP, with a working FREE 2D mockup link (opens the same modal).
      quoteNote=document.createElement('div');
      quoteNote.style.cssText='display:none;margin:12px 0;padding:10px 12px;background:#fff7ed;border:1px solid #f59e0b;border-radius:8px;font-size:12.5px;color:#7c2d12;line-height:1.5;';
      quoteNote.innerHTML='Orders over 800 sq ft qualify for bulk production rates — request your <a href="#" class="bdsusa-quote-mockup" style="color:#b45309;font-weight:700;text-decoration:underline;">Bulk Request</a> for a tailored quote and visual proof.';
      placeTop(quoteNote);
      var qmk=quoteNote.querySelector('.bdsusa-quote-mockup');
      if(qmk){ qmk.addEventListener('click', function(ev){ ev.preventDefault(); bdsuOpenCsp(); }); }
    }

    buildUI(); buildNotes();

    /* One product (Poly Canvas) loads bds-fabric-calculator.js as well. That script
       owns the pricing block ABOVE the Add to cart button, so this script's own
       price/ladder block renders a SECOND, duplicate ladder BELOW the button.
       Hide only that block here - the seam note and the over-800 quote note built
       by buildNotes() are still required on those products. */
    try{
      var _dupLadder = document.querySelector('script[src*="bds-fabric-calculator"]');
      if(_dupLadder && ui){ ui.style.display = 'none'; }
    }catch(_dl){}


    // Per-sq.ft + total both solid black; hide the greyed "Total:" row (total now shows inline in the headline)
    if(priceEl) priceEl.style.color='#000';
    if(elHead) elHead.style.color='#000';
    var totalRow = totalEl ? (totalEl.closest('.pfab__total-row') || totalEl.parentElement) : null;
    if(totalRow) totalRow.style.display='none';

    var state={blocked:false,wt:0,pp:0,seam:false};
    function calc(){
      var d=curFab();
      if(idInput && d && d.vid) idInput.value=d.vid;
      var rate=d?(parseFloat(d.rate)||0):0;
      var w=parseFloat(wEl&&wEl.value)||0, h=parseFloat(hEl&&hEl.value)||0;
      var qty=parseInt(qtyEl&&qtyEl.value,10)||1; if(qty<1)qty=1;
      var u=(unitEl&&unitEl.value||'feet').toString().toLowerCase();
      var f=UNIT[u]!=null?UNIT[u]:1;
      var wFt=w*f, hFt=h*f, sqftPiece=wFt*hFt, sqft=sqftPiece*qty, both=(w>0&&h>0);

      // ladder always reflects the selected fabric (even before a size is entered)
      renderLadder(sqft, d);
      // default headline shows the best (lowest) all-in rate as "from ..."
      var lowest = d ? effAt(maxSqftFor(d), d) : 0;

      // Cap is on the TOTAL area (width × height × quantity), not one piece.
      if(both && sqft>MAX_SQFT){
        state.blocked=true; state.wt=0; state.pp=0; state.seam=false;
        if(priceEl) priceEl.textContent='—'; if(totalEl) totalEl.textContent='—';
        if(elTotal) elTotal.style.display='none';
        if(elHead) elHead.textContent='Over 800 sq.ft — request a free quote';
        if(elNudge) elNudge.style.display='none';
        if(quoteNote) quoteNote.style.display='block';
        if(seamNote){ seamNote.style.display='none'; seamNote.style.boxShadow=''; }
        if(addBtn){ addBtn.disabled=true; addBtn.style.opacity='0.5'; addBtn.style.cursor='not-allowed'; }
        return;
      }
      if(quoteNote) quoteNote.style.display='none';

      // ── FEE-BASIS FIX (matches Fabric Price app, feeBasis "line") ──────────────────
      //  total sq ft = width × height × quantity  ( = `sqft` )
      //  line total  = ceil( totalSqFt × rate  +  fee(totalSqFt)  +  finishing × qty )
      //    • flat/shipping fee looked up by the TOTAL sq ft and added ONCE per line
      //    • finishing/add-ons are per piece → × qty
      //    • line total rounded UP to a whole dollar
      //  _price (sent to cart) = ceil( lineTotal ÷ qty , to the cent ) → qty × _price never undercharges
      var addon=finishingTotal();
      var lineTotal = both ? Math.ceil(sqft*rate + flatFor(sqft,d) + addon*qty) : 0;
      var pricePP   = lineTotal>0 ? Math.ceil((lineTotal/qty)*100)/100 : 0; // per-piece, ceil to the cent
      var wt        = pricePP*qty;                                          // == qty × _price (what the cart charges)
      state.blocked=false; state.wt=wt; state.pp=pricePP;
      /* floorPP removed — FLAGGED FOR TARUN. The old per-piece minimum compared a
         per-piece dollar total against a per-sq-ft figure (a unit mismatch), so it
         never applied to real sizes. Reinstate only if Tarun confirms a minimum
         per-piece price is actually wanted, and define it in matching units. */

      if(both&&wt>0){
        var curEff = wt/sqft;                       // all-in per-sq.ft incl. finishing for the headline total
        var curEffNoFin = effAt(sqft,d);            // per-sq.ft used for nudge comparison (matches ladder basis)
        if(priceEl) priceEl.textContent = per(wt/sqft) + '/sq.ft, all-in  |  ' + money(wt);
        if(totalEl) totalEl.textContent = money(wt);
        if(elHead) elHead.textContent = per(wt/sqft) + ' /sq.ft, all-in';
        if(elTotal) elTotal.style.display='none';
        renderNudge(sqft, curEffNoFin, d);
      } else {
        if(priceEl) priceEl.textContent = lowest? ('from '+per(lowest)+'/sq.ft, all-in') : priceEl.textContent;
        if(elHead) elHead.textContent = lowest? ('from '+per(lowest)+' /sq.ft, all-in') : '';
        if(elTotal) elTotal.style.display='none';
        if(elNudge) elNudge.style.display='none';
      }

      if(seamNote){
        // Same message for every fabric; the per-fabric roll width only decides WHEN to show it.
        var sInfo = seamFor(curFabName());
        var showSeam=false;
        if(!(sInfo && sInfo.seamless)){
          var lft = sInfo ? sInfo.ft : SEAM_LIMIT_FT;   // per-fabric roll width (ft): seam needed only when the shorter side exceeds it
          if(both && wFt>lft && hFt>lft) showSeam=true;
        }
        seamNote.style.display = showSeam ? 'block' : 'none';
        if(!showSeam) seamNote.style.boxShadow='';
        state.seam = showSeam;
      }
      if(addBtn){ addBtn.disabled=false; addBtn.style.opacity=''; addBtn.style.cursor=''; }
    }

    function schedule(){ setTimeout(calc,0); }
    [fabricSel,wEl,hEl,unitEl,qtyEl].forEach(function(el){ if(el){ el.addEventListener('input',schedule); el.addEventListener('change',schedule); } });
    Object.keys(FINISH).forEach(function(label){ var s=selFor(label); if(s){ s.addEventListener('change',schedule); s.addEventListener('input',schedule); } });
    schedule(); setTimeout(calc,300); setTimeout(calc,900);

    if(form){
      form.addEventListener('submit', function(e){
        /* Stand aside when bds-fabric-calculator.js owns this form: it publishes
           window.__bdsExpect after pricing. Two handlers on one form previously
           collided - this one won via stopImmediatePropagation and, with no rate
           config for the product, computed 0 and silently killed Add to cart. */
        try{ if(window.__bdsExpect && window.__bdsExpect.cents > 0) return; }catch(_g){}
        try{
          calc();
          if(state.blocked){ e.preventDefault(); e.stopImmediatePropagation(); return false; }
          if(state.wt<=0){ e.preventDefault(); e.stopImmediatePropagation(); if(wEl&&(!wEl.value||parseFloat(wEl.value)<=0)){ wEl.focus(); } return false; }
          // When a seam applies, require the acknowledge checkbox before adding to cart.
          if(state.seam){ var _ack=seamNote&&seamNote.querySelector('.bdsusa-seam-ack'); if(_ack&&!_ack.checked){ e.preventDefault(); e.stopImmediatePropagation(); seamNote.style.boxShadow='0 0 0 2px #16a34a'; seamNote.scrollIntoView({behavior:'smooth',block:'center'}); return false; } }
          e.preventDefault(); e.stopImmediatePropagation();
          var d=curFab();
          var qty=parseInt(qtyEl&&qtyEl.value,10)||1; if(qty<1)qty=1;
          var props={ 'Width':(wEl&&wEl.value)||'', 'Height':(hEl&&hEl.value)||'', 'Unit':(unitEl&&unitEl.value)||'', 'Pieces':String(qty) };
          Object.keys(FINISH).forEach(function(label){ var s=selFor(label); if(s&&s.value&&s.value!=='None'&&s.value.indexOf('No Proof')!==0) props[label]=s.value; });
          // Show the real piece count at cart/checkout instead of the $1-base quantity:
          // send quantity = Pieces and _price = per-unit dollars, which the store's "custom-pricing"
          // Cart Transform reads to price the line (qty × _price == the line total shown above).
          // _price is the per-piece figure already rounded UP to the cent in calc() (state.pp),
          // so qty × _price can never undercharge the line.
          props['_price']=String(state.pp>0 ? state.pp : Math.ceil((state.wt/qty)*100)/100);
          var vid=(d&&d.vid)?d.vid:(idInput&&idInput.value);
          var body={ items:[{ id: vid, quantity: qty, properties: props }] };
          if(addBtn) addBtn.disabled=true;
          fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)})
            .then(function(r){return r.json();})
            .then(function(){ window.location.href='/cart'; })
            .catch(function(){ if(addBtn) addBtn.disabled=false; window.location.href='/cart'; });
          return false;
        }catch(err){ try{ e.preventDefault(); e.stopImmediatePropagation(); }catch(_e){} return false; }
      }, true);
    }
  });
})();